/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_2Inputs */

const en_gc_search_guides_gridcraft_online_sections_2_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check that the download completed. Find the newest file in your browser’s download list; repeated downloads can have similar names.`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认下载完成，在浏览器下载列表中找到最新文件；多次下载的文件名可能很相近。`)
};

/**
* | output |
* | --- |
* | "Check that the download completed. Find the newest file in your browser’s download list; repeated downloads can have similar names." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_steps_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_steps_2(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_steps_2(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_steps_2 as "gc.search_guides.gridcraft_online.sections.2.steps.2" }